module.exports = __webpack_public_path__ + "img/tech_info.aa167766.png";